/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { TableBody } from '@material-ui/core';
import PlatformIpPoolNumber from '../../../interfaces/platform/PlatformIpPoolNumber';
import PaperedTable from '../../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import I18n from '../../../components/Translate/I18n';
import { PlatformIpPoolNumberHistoryCollection } from '../../../interfaces/collections/PlatformIpPoolNumberHistory';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import SettingsButton from '../../../components/Buttons/SettingsButton';
import { history } from '../../../core/history';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';
import CardHeaderExt from '../../../components/Heading/CardHeaderExt';

type IpHistoryType = {
    classes: any;
    ip: PlatformIpPoolNumber;
};

const IpHistory: FunctionComponent<IpHistoryType> = ({ ip, classes }): React.ReactElement => {
    const [ipHistory, setIpHistory] = useState<PlatformIpPoolNumberHistoryCollection | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const itemLoaders = new ItemLoaders(dispatch);
        itemLoaders.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_ip_pool_number_histories')),
            'msisdn_history_storage_view_get',
            [{ name: 'platformIpPoolNumber', value: ip.id }],
            [
                { name: 'deleted', value: 'asc' },
                { name: 'id', value: 'desc' },
            ],
            (data: PlatformIpPoolNumberHistoryCollection) => {
                setIpHistory(data);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [ip, dispatch]);

    const goToProduct = (item: { uri: string }): void => {
        history.push(FormGeneralHelper.getRouteUrl('/sim-card-edit' + item.uri));
    };

    const tableRowRoot = { root: classes.tableRowRoot };
    const tableCellRoot = { root: classes.tableCellRootBordered };

    return (
        <Card>
            <CardHeaderExt trans="pools:pool.parring_history" />
            <CardBody style={{ overflow: 'auto' }}>
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="none" align="left">
                                <I18n trans="general:common.commands" />
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:pool.msisdn"
                                    fieldName="imsi"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:pool.imsi"
                                    fieldName="imsi"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:ip.start_usage"
                                    fieldName="parentProductDate"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <TableHeaderContentCell
                                    textAlign="center"
                                    title="pools:ip.end_usage"
                                    fieldName="parentProductDate"
                                    showSort={false}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="number"
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {ipHistory &&
                            ipHistory['hydra:member'] &&
                            ipHistory['hydra:member'].map((ipPool) => {
                                return (
                                    <TableRow key={'sim_card_asd_' + ipPool.id} classes={tableRowRoot}>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            <SettingsButton
                                                callback={goToProduct}
                                                callbackParam={{ uri: ipPool.simCard }}
                                                tooltipTitle="pools:msisdn.produkt_view"
                                            />
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {ipPool.msisdn}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {ipPool.imsi}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {ipPool.startUsage && DateHelperTs.format(ipPool.startUsage)}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="center">
                                            {ipPool.endUsage && DateHelperTs.format(ipPool.endUsage)}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </PaperedTable>
            </CardBody>
        </Card>
    );
};

export default withStyles(oplAppStyle)(IpHistory);
